import React from 'react';
import classNames from 'classnames';
import { getShortDurationString } from 'lib/DateTime';
import { recipe as recipePropType } from 'lib/CustomPropTypes';
import InfoTile from 'components/Recipe/InfoTile';
import Ratings from 'components/Ratings';
import get from 'lodash.get';
import PropTypes from 'prop-types';

const RecipeInfo = ({ content, from }) => {
  if (!content) {
    return null;
  }

  const {
    id,
    type,
    cookTime,
    prepTime,
    servingSize,
    nutrition,
  } = content;

  const aggregateRating = content.aggregateRating || {};

  if (type !== 'recipe') {
    return null;
  }

  const cookTimeStr = getShortDurationString(cookTime);
  const prepTimeStr = getShortDurationString(prepTime);
  const calories = get(nutrition, 'calories');
  const isOnlyRating = (!cookTimeStr && !prepTimeStr && !servingSize && !calories);

  const className = classNames({
    'recipe-info--rail black-print': from === 'recipe-body',
    'recipe-info--header dn-print': from === 'article-hero',
    'recipe-info--only-rating': isOnlyRating,
  });

  return (
    <div className={classNames(
      className,
      {
        'mb0-print': isOnlyRating,
      },
    )}
    >
      <InfoTile value={cookTimeStr} label="COOK TIME" />
      <InfoTile value={prepTimeStr} label="PREP TIME" />
      <InfoTile value={servingSize} label="SERVINGS" />
      <InfoTile value={calories} label="CALORIES" />
      <Ratings
        id={id}
        ratingID={aggregateRating.id}
        ratingCount={aggregateRating.ratingCount}
        ratingValue={aggregateRating.ratingValue}
      />
    </div>
  );
};

RecipeInfo.propTypes = {
  content: recipePropType.isRequired,
  from: PropTypes.string.isRequired,
};

export default RecipeInfo;
